import { WriteAuditLogAction } from './actions';
import { AuditLogsState } from './state';
import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';
import { AuditLog } from 'types/audit-log';
import { compareAuditTimeStamp } from 'helpers/date-helper';

const initialState: AuditLogsState = {
  auditLogs: []
};

export const auditLogsReducer = createSwitch(initialState, [
  createCase(new WriteAuditLogAction({} as AuditLog), (state, action) => {
    const auditLogs = state.auditLogs.sort(compareAuditTimeStamp);
    const auditLogsSorted = update([action.auditLog], { $push: auditLogs });
    return update(state, {
      auditLogs: { $set: auditLogsSorted }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/components/audit-logs/reducer.ts